import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const WaveRegionPlayIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="24" height="24" rx="12" fill={fillColor || '#141516'} />
      <path
        d="M14.6427 11.7856L10.3786 9.22717C10.212 9.1272 10 9.24722 10 9.44155V14.5585C10 14.7528 10.212 14.8728 10.3786 14.7728L14.6427 12.2144C14.8045 12.1173 14.8045 11.8827 14.6427 11.7856Z"
        fill={fillColor || 'white'}
      />
    </svg>
  );
};

export { WaveRegionPlayIcon };
